// v2 Knowledge Workspaces — org-level skill catalog.
//
// Users create + edit + delete custom skills here. Workspaces attach a
// subset of these skills via the workspace's Skills tab (see
// `apps/console/src/components/workspaces/SkillsTab.tsx`).
//
// This route was previously a legacy redirect to /agents/skills (the 2026-07
// nav rename moved Skills-for-agents under /agents). In v2 the `/skills` URL
// is repurposed for the org-level knowledge skill catalog — the redirect was
// removed 2026-07-21 (Opus 4.7 follow-up).
import { createFileRoute } from '@tanstack/react-router';

import { PageHeader } from '../components/common/PageHeader';
import { SkillsCatalog } from '../components/skills/SkillsCatalog';

export const Route = createFileRoute('/skills')({ component: SkillsPage });

function SkillsPage() {
  return (
    <>
      <PageHeader title="Document processing skills" />
      <SkillsCatalog />
    </>
  );
}
